import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState<T> {
    data: T;
    successMessage: string | null;
    error: string | null;
    isFetching: boolean;
}

const createFormSlice = <T>(name: string, initialFormData: T, initialStateOverrides: Partial<FormState<T>> = {}) => {
    const initialState: FormState<T> = {
        data: initialFormData,
        successMessage: null,
        error: null,
        isFetching: true,
        ...initialStateOverrides,
    };

    return createSlice({
        name,
        initialState,
        reducers: {
            formSent(state, action: PayloadAction<string>) {
                state.successMessage = action.payload;
                state.error = null;
                state.isFetching = false;
            },
            setError(state, action: PayloadAction<string>) {
                state.error = action.payload;
                state.isFetching = false;
            },
            resetSuccessMessage(state) {
                state.successMessage = null;
            },
        },
    });
};

export default createFormSlice;
